import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import BackButton from '../../../components/BackButton'
import PrivacyPolicyContent from '../../../components/PrivacyPolicyContent'

const PrivacyPolicy = () => {
  const history = useHistory()
  const [isFloating, setIsFloating] = useState(false)
  const VISIBLE_HEIGHT = 150
  const BUTTON_HEIGHT = '82px'

  useEffect(() => {
    window.scrollTo(0, 0)
    document.body.style.marginBottom = BUTTON_HEIGHT
    window.addEventListener('scroll', () => {
      window.scrollY > VISIBLE_HEIGHT ? setIsFloating(true) : setIsFloating(false)
    })
  }, [])

  const handleBackPage = () => {
    document.body.style.removeProperty('margin-bottom')
    history.goBack()
  }

  return (
    <>
      <BackButton text='Voltar' onClick={handleBackPage}/>
      <PrivacyPolicyContent />
      <BackButton text='Voltar' outline isFloating={isFloating} onClick={handleBackPage}/>
    </>
  )
}

export default PrivacyPolicy
